export default __webpack_public_path__ + "static/media/trbotsnare.baaf82bc.mp3";